import { Component, Input, OnInit } from "@angular/core"
import { ModalRef } from "../../modal/modal-ref"

@Component({
    selector: "app-share-assignment-code-modal",
    templateUrl: "./share-assignment-code-modal.component.html",
    styleUrls: ["./share-assignment-code-modal.component.scss"],
})
export class ShareAssignmentCodeModalComponent implements OnInit {
    @Input() code: string = ""
    public shareLink: string = ""
    constructor(public activeModal: ModalRef) {}

    public ngOnInit() {
        this.shareLink = `${window.location.origin}/student/code/${this.code}/`
    }
}
